(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('SecurityPolicy', SecurityPolicy);

    SecurityPolicy.$inject = ['$resource'];

    function SecurityPolicy ($resource) {
        var resourceUrl =  'api/orgId/:orgId/security-policy/:themeID';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/security-policy'
        	 },
        	 'getEntityPermissions':{
        		 params: {orgId:'@orgId'},
        		 isArray: true,
         	     url: 'api/orgId/:orgId/security-policy/entity-permissions'
        	 },
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },
             'themesForOrganisation': { method: 'GET', isArray: true,
                params: {orgId:'@orgId'},
                url: 'api/orgId/:orgId/themes'
             },
             'actionsForOrgAndTheme': { method: 'GET', isArray: true,
                params: {orgId:'@orgId', themeId: '@themeId'},
                url: 'api/orgId/:orgId/actions-for-theme/:themeId/themeId'
             },
        	 'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/orgId/:orgId/security-policy',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 return angular.toJson(copy);
                 }                
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/security-policy',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              }
              
        });
    }
})();
